import { StyleSheet } from "../../react-native-components"

export const styles = StyleSheet.create({
    childContainer: {
        minHeight: 200
    }
})